module.exports = __webpack_public_path__ + "static/media/marker_inactive.35c25edc.svg";